import { render, staticRenderFns } from "./RateCom.vue?vue&type=template&id=85e98cb8&scoped=true&"
import script from "./RateCom.vue?vue&type=script&lang=ts&"
export * from "./RateCom.vue?vue&type=script&lang=ts&"
import style0 from "./RateCom.vue?vue&type=style&index=0&id=85e98cb8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85e98cb8",
  null
  
)

export default component.exports